export default "/images/vendor/flag-icon-css/flags/1x1/kp.svg?2e79afa21a3e610e55511db40f3ef092";